import { Action } from '@ngrx/store';
import {FloorMapFilters} from '../floor-map.model';

export enum MapFilterActionTypes {
  LoadMapFilters = '[MapFilter] Load MapFilters',
  SelectMapFilters = '[MapFilter] Select MapFilters'
}

export class LoadMapFilters implements Action {
  readonly type = MapFilterActionTypes.LoadMapFilters;
  constructor(public payload: FloorMapFilters) {
  }
}

export class SelectMapFilters implements Action {
  readonly type = MapFilterActionTypes.SelectMapFilters;
  constructor(public payload: FloorMapFilters) {}
}


export type MapFilterActions = LoadMapFilters | SelectMapFilters;
